import styled from "styled-components";

export const FilterToggleWrapper = styled.div.attrs({
    role: 'group',
    ariaLabel: 'Selected filters'
})`
    background: transparent;
    border: none;
    padding: 0;
    margin-right: 8px;
    margin-bottom: 8px;
`;

